import { Autocomplete, Chip, TextField } from '@mui/material';
import { textFieldProps } from '../textFieldProps';
import type { FieldComponentProps, FieldTypeSpec } from '../types';

export interface TagsConfig {
  suggestions?: string[];
  /** Normalise each tag, e.g. file extensions are kept lowercase without a dot. */
  normalise?: 'lower' | 'upper' | 'extension';
}

function normalise(tag: string, mode: TagsConfig['normalise']): string {
  const t = tag.trim();
  if (mode === 'lower') return t.toLowerCase();
  if (mode === 'upper') return t.toUpperCase();
  if (mode === 'extension') return t.toLowerCase().replace(/^\.+/, '');
  return t;
}

export function TagsInput({ field, value, onChange, onBlur, error }: FieldComponentProps<string[] | null, TagsConfig>) {
  const { suggestions = [], normalise: mode } = field.config;
  return (
    <Autocomplete multiple freeSolo options={suggestions} value={value ?? []} disabled={field.disabled}
                  size={field.size} onBlur={onBlur}
                  onChange={(_e, next) => onChange([...new Set(next.map((t) => normalise(String(t), mode)).filter(Boolean))])}
                  renderTags={(tags, getTagProps) => tags.map((t, i) => {
                    const { key, ...chip } = getTagProps({ index: i });
                    return <Chip key={key} size="small" label={t} {...chip} />;
                  })}
                  renderInput={(params) => {
                    const base = textFieldProps(field, error);
                    return <TextField {...params} {...base} slotProps={{ ...base.slotProps, inputLabel: { ...params.InputLabelProps, shrink: true } }} />;
                  }} />
  );
}

export const tagTypes: Record<string, FieldTypeSpec> = {
  tags: { component: TagsInput, display: (v) => (v as string[]).join(', ') },
};
